var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.012,
    height: 11.012,
    viewBox: "0 0 11.012 11.012",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-dashboard",
    "data-name": "Icon material-dashboard",
    d: "M4.5,10.285H9.128V4.5H4.5Zm0,4.628H9.128V11.441H4.5Zm5.785,0h4.628V9.128H10.285Zm0-10.412V7.971h4.628V4.5Z",
    transform: "translate(-4.2 -4.2)",
    fill: "none",
    stroke: "#0603fd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.efd41c3c1a9adc272d3cf3d2977ea654.svg";
export { ForwardRef as ReactComponent };